<template>
  <div v-if="labels">
    <vs-row>
      <vx-card class="max-w-lg mt-4">
        <transition name="fade">
          <segmentation-row icon="GiftIcon" v-if="showAge" @onDelete="onDeleteAge">
            <div>Age</div>
            <div class="text-grey">between {{ guestQuery.ageRange[0] }} - {{ guestQuery.ageRange[1] }}</div>

            <template v-slot:result>
              <vs-slider v-model="guestQuery.ageRange" />
            </template>
          </segmentation-row>
        </transition>

        <transition name="fade">
          <segmentation-row icon="TagIcon" class="mt-4" v-if="showLabels" @onDelete="onDeleteLabels">
            <div>Labels</div>
            <div class="text-grey">Must have labels</div>

            <template v-slot:result>
              <treeselect
                v-if="labels"
                ref="treeselect"
                v-model="guestQuery.labels"
                :multiple="true"
                :options="mappedLabels"
                placeholder="Select labels"
                :flatten-search-results="true"
                value-consists-of="LEAF_PRIORITY"
              >
                <div slot="value-label" slot-scope="{ node }">{{ node.raw.label }}</div>
              </treeselect>
            </template>
          </segmentation-row>
        </transition>
        <transition name="fade">
          <segmentation-row
            icon="ShoppingCartIcon"
            class="mt-4"
            v-if="showInterest"
            @onDelete="onDeleteInterest"
          >
            <div>Interest</div>
            <div class="text-grey">Must have interest</div>

            <template v-slot:result>
              <div>
                <treeselect
                  v-if="labels"
                  ref="treeselect"
                  v-model="guestQuery.interestKey"
                  :multiple="false"
                  :options="mappedInterests"
                  placeholder="Select interest"
                  :flatten-search-results="true"
                  value-consists-of="LEAF_PRIORITY"
                >
                  <div slot="value-label" slot-scope="{ node }">{{ node.raw.label }}</div>
                </treeselect>
              </div>
              <div class="mx-2">=</div>
              <div class="flex-grow">
                <vs-input style="width: 160px" v-model="guestQuery.interestValue"></vs-input>
              </div>
            </template>
          </segmentation-row>
        </transition>

        <transition name="fade">
          <segmentation-row icon="LinkIcon" class="mt-4" v-if="showConsents" @onDelete="onDeleteConsents">
            <div>Consents</div>
            <div class="text-grey">Must have consents for specified venues</div>

            <template v-slot:result>
              <div class="flex flex-col">
                <venue-selector
                  v-model="guestQuery.consentVenues"
                  :multiple="true"
                  placeholder="Select venues"
                />
                <div class="flex-shrink mt-2">
                  <treeselect
                    v-if="labels"
                    ref="treeselect"
                    v-model="guestQuery.consentTypes"
                    :multiple="true"
                    :options="mappedConsents"
                    placeholder="Select consents"
                    :flatten-search-results="true"
                    value-consists-of="LEAF_PRIORITY"
                  >
                    <div slot="value-label" slot-scope="{ node }">{{ node.raw.label }}</div>
                  </treeselect>
                </div>
              </div>
            </template>
          </segmentation-row>
        </transition>

        <div class="flex items-center" v-if="!showAge || !showLabels || !showInterest || !showConsents">
          <div
            class="p-2 rounded-lg transition-all duration-150"
            :class="{ 'pl-4': hoveringNew }"
            @mouseenter="hoveringNew = true"
            @mouseleave="hoveringNew = false"
          >
            <div class="flex items-center pr-8">
              <div class="mr-4 flex items-center">
                <feather-icon icon="PlusIcon" svgClasses="w-4 h-4"></feather-icon>
                <span class="ml-2">Add new condition</span>
              </div>

              <div
                class="color-box flex-shrink-0 mx-1 cursor-pointer"
                :class="{ hide: !hoveringNew, hidden: showAge }"
                @click="guestQuery.hasAge = true"
              >
                <feather-icon icon="GiftIcon" svgClasses="w-4 h-4"></feather-icon>
              </div>
              <div
                class="color-box flex-shrink-0 mx-1 cursor-pointer"
                :class="{ hide: !hoveringNew, hidden: showLabels }"
                @click="guestQuery.hasLabels = true"
              >
                <feather-icon icon="TagIcon" svgClasses="w-4 h-4"></feather-icon>
              </div>
              <div
                class="color-box flex-shrink-0 mx-1 cursor-pointer"
                :class="{ hide: !hoveringNew, hidden: showInterest }"
                @click="guestQuery.hasInterest = true"
              >
                <feather-icon icon="ShoppingCartIcon" svgClasses="w-4 h-4"></feather-icon>
              </div>
              <div
                class="color-box flex-shrink-0 mx-1 cursor-pointer"
                :class="{ hide: !hoveringNew, hidden: showConsents }"
                @click="guestQuery.hasConsents = true"
              >
                <feather-icon icon="LinkIcon" svgClasses="w-4 h-4"></feather-icon>
              </div>
            </div>
          </div>
        </div>
        <!-- <vs-row vs-justify="center" class="mt-8">
            <div class="color-box flex-shrink-0 mx-1">
              <feather-icon icon="GiftIcon" svgClasses="w-4 h-4"></feather-icon>
            </div>
            <div class="color-box flex-shrink-0 mx-1">
              <feather-icon icon="TagIcon" svgClasses="w-4 h-4"></feather-icon>
            </div>
            <div class="color-box flex-shrink-0 mx-1">
              <feather-icon icon="ShoppingCartIcon" svgClasses="w-4 h-4"></feather-icon>
            </div>
            <div class="color-box flex-shrink-0 mx-1">
              <feather-icon icon="LinkIcon" svgClasses="w-4 h-4"></feather-icon>
            </div>
        </vs-row> -->
      </vx-card>
    </vs-row>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Treeselect from "@riophae/vue-treeselect";
// import styles
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import VenueSelector from "@/components/VenueSelector.vue";

import SegmentationRow from "./SegmentationRow.vue";
export default {
  components: {
    Treeselect,
    SegmentationRow,
    VenueSelector,
  },
  props: {
    guestQuery: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      hoveringNew: false,
    };
  },
  methods: {
    onDeleteAge() {
      this.guestQuery.hasAge = false;
    },
    onDeleteLabels() {
      this.guestQuery.hasLabels = false;
    },
    onDeleteInterest() {
      this.guestQuery.hasInterest = false;
    },
    onDeleteConsents() {
      this.guestQuery.hasConsents = false;
    },
  },
  computed: {
    ...mapGetters({
      labels: "guestSegmentation/labels",
      interests: "guestSegmentation/interests",
      consentTypes: "guestProfiles/consentTypes",
      consentNames: "guestProfiles/consentNames",
    }),
    showAge() {
      return this.guestQuery.hasAge;
    },
    showLabels() {
      return this.guestQuery.hasLabels;
    },
    showInterest() {
      return this.guestQuery.hasInterest;
    },
    showConsents() {
      return this.guestQuery.hasConsents;
    },
    mappedLabels() {
      return this.labels.map(label => ({
        id: label,
        label: label,
      }));
    },
    mappedInterests() {
      return this.interests.map(interest => ({
        id: interest.name,
        label: interest.name,
      }));
    },
    mappedConsents() {
      let consents = [];

      this.consentTypes.forEach((type, idx) => {
        const consentName = this.consentNames[idx];
        consents.push({
          id: type,
          label: consentName,
        });
      });
      return consents;
    },
  },

  async mounted() {
    this.$vs.loading();
    await this.$store.dispatch("guestSegmentation/get");
    this.$vs.loading.close();
  },
};
</script>

<style lang="scss" scoped>
.color-box {
  width: 40px;
  height: 40px;
  border-radius: 12px;
  background-color: rgba(var(--vs-primary)) !important;
  box-shadow: 0px 15px 40px -10px rgba(var(--vs-primary), 0.9);

  display: flex;
  align-items: center;
  justify-content: center;

  color: white;

  opacity: 1;
  transition: opacity 0.15s;

  &.hide {
    opacity: 0;
    pointer-events: none;
  }
}
</style>